import { render, staticRenderFns } from "./VersionsDialogBox.vue?vue&type=template&id=0c6b785b&scoped=true&"
import script from "./VersionsDialogBox.vue?vue&type=script&lang=js&"
export * from "./VersionsDialogBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6b785b",
  null
  
)

export default component.exports